module.exports = __webpack_public_path__ + "static/media/tony.66384bd3.svg";